<div *ngIf="value" class="badge-container" [ngClass]="{red: isRed, active: isActive}">
  {{ value | numberLimit : 2 }}
</div>
